import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadedFile } from '../../models/uploaded-file.model';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-add-liability-scan-mobile',
  styleUrls: ['./add-liability-scan-mobile.component.scss'],
  templateUrl: './add-liability-scan-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddLiabilityScanMobileComponent implements OnChanges {
  @Input() public files: UploadedFile[] = [];
  @Input() public error: string;
  @Input() public uploading: boolean;
  @Input() public disabled: boolean;
  @Input() public filesAdded: (event: Event) => void;
  @Input() public checkPermissions: (fileInput: HTMLInputElement) => Promise<void>;
  @Input() public remove: (index: number) => void;
  @Input() public submit: () => void;

  public readonly formName = 'newLiability';
  public documentPreviewVisible = false;

  constructor(private snackbar: MatSnackBar) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const errorChange = changes['error'];
    if (errorChange && errorChange.currentValue) {
      this.showSnackbar();
    }
  }

  private showSnackbar(): void {
    // this.snackbar.open(this.error, 'Zamknij', { duration: DURATION_5S });
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
